import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Scheduler, Button, SelectBox } from "devextreme-react";
import {
  doGetOpeningsAppointments,
  setHideShowWizard,
  setStepWizard,
  doGetWeekAppointments,
  doGetCenters,
  setCenterIdOpening,
  doGetQuotesList,
  doGetCenterConfiguration,
  doGetDataToUpdateWeek,
  doGetListConfigurations,
  openCloseModalDeleteOpening,
  doGetDataToUpdateOpening,
  resetState
} from "./actions";

import { showToastError } from "../../../../Main/actions";
import ModalWizard from "./wizard/modal";
import { CuposItem } from "./cuposItem";
import { numberToDay } from "../../../../../helpers/strings";
import validaciones from "../../../../../helpers/validaciones";

const mes = "Mes";
const semana = "Semana";
const dia = "Dia";
const defaultStartHour = "10:00";
const defaultEndHour = "12:00";
const defaultInterval = 15;

class OpenningScheduler extends React.Component {
  constructor(props) {
    super(props);
    this.cellClick = null;
    this.currentView = mes;
    this.currentDate = new Date();
    this.lastTimeInterval = "";
  }

  componentDidMount = () => {
    if (this.props.centrosList && this.props.centrosList.length === 0) this.props.dispatch(doGetCenters());
    if (!this.props.listaAppointments) this.props.dispatch(doGetOpeningsAppointments(this.props.centerId));
    if (this.props.listQuotes && this.props.listQuotes.length === 0) this.props.dispatch(doGetQuotesList());
  }

  componentWillUnmount = () => {
    this.props.dispatch(resetState())
  }

  shouldComponentUpdate = (nextProps) => {
    if (this.props.Opening !== nextProps.Opening) return false;
    return true;
  }

  getNumber = (dateTime, max = false) => {
    let [hora, min] = dateTime.split(":");
    hora = parseInt(hora, 10);
    if (min > 0 && max) {
      hora += 1;
    }
    if (min === "30") {
      return `${hora}.5`;
    }
    return hora;
  }
  getFirstHour = () => {
    const { config } = this.props;
    const values = [];
    if (config.minWorkDay) values.push(this.getNumber(config.minWorkDay))
    if (config.minSatWork) values.push(this.getNumber(config.minSatWork))
    if (config.minSunWork) values.push(this.getNumber(config.minSunWork))

    if (!values.length) return this.getNumber(defaultStartHour);
    return Math.min(...values);
  }

  getLastHour = () => {
    const { config } = this.props;
    const values = [];
    if (config.maxWorkDay) values.push(this.getNumber(config.maxWorkDay))
    if (config.maxSatWork) values.push(this.getNumber(config.maxSatWork))
    if (config.maxSunWork) values.push(this.getNumber(config.maxSunWork))

    if (!values.length) return this.getNumber(defaultEndHour);
    return Math.max(...values);
  }

  getDataSource = () => {
    switch (this.currentView) {
      case semana: {
        return this.props.weekAppointments;
      }
      case dia: {
        return this.props.weekAppointments;
      }
      default: {
        return this.props.listaAppointments;
      }
    }
  }

  handleChange = (e) => {
    this.props.dispatch(doGetCenterConfiguration(e.value));
    this.props.dispatch(setCenterIdOpening(e.value));

    this.loadWeekData();
    this.loadMothData();
  }

  handleAppointmentClick = (event) => {
    switch (this.currentView) {
      case semana: {
        event.cancel = true;
        this.props.dispatch(doGetDataToUpdateWeek(event.appointmentData));
        break;
      }
      case dia: {
        event.cancel = true;
        this.props.dispatch(doGetDataToUpdateWeek(event.appointmentData));
        break;
      }
      case mes: {
        break;
      }
      default: {
        break;
      }
    }
  }

  openNewOpening = () => {
    if (this.props.Opening.IdCentro !== null) {
      this.props.dispatch(doGetListConfigurations(this.props.Opening.IdCentro));
      this.props.dispatch(setHideShowWizard(true));
      this.props.dispatch(setStepWizard({
        isNewApertura: true,
        stepOne: true,
        stepTwo: false,
        stepThree: false,
        stepFour: false,
        stepSuccess: false,
      }));
    } else {
      this.props.dispatch(showToastError("Debe seleccionar un centro antes de crear una apertura"));
    }
  }

  loadWeekData = (startDate) => {
    this.props.dispatch(doGetWeekAppointments(this.props.centerId, startDate));
  }

  loadDayData = (startDate) => {
    this.props.dispatch(doGetWeekAppointments(this.props.centerId, startDate));
  }

  loadMothData = (startDate) => {
    this.props.dispatch(doGetOpeningsAppointments(this.props.centerId, startDate));
  }

  handleDelete = (id) => {
    this.props.dispatch(openCloseModalDeleteOpening(true, id));
  }

  handleEdit = (data) => {
    const listOpening = [...this.props.listaAppointments];
    const openingSelected = listOpening.find((o) => o.Id === data.Id);
    this.props.dispatch(doGetListConfigurations(this.props.centerId));
    this.props.dispatch(doGetDataToUpdateOpening(openingSelected, this.props.centerId));
  }

  handleOptionChane = (e) => {
    if (e.name === "currentDate" || e.name === "currentView") {
      this.currentView = e.component.option("currentView");
      this.currentDate = e.component.option("currentDate");
      switch (this.currentView) {
        case semana: {
          this.loadWeekData(this.currentDate);
          break;
        }
        case mes: {
          this.loadMothData(this.currentDate);
          break;
        }
        case dia: {
          this.loadDayData(this.currentDate);
          break;
        }
        default: {
          break;
        }
      }
    }
  }

  renderMonthItem = (data, index, element) => {
    if (data.Quotas) return;
    ReactDOM.render(
      <div className="opening-view-month-text">
        {data.text}
      </div>
      , element
    );
  }

  renderWeekItem = (data, index, element) => {
    if (!data.Quotas) return;
    ReactDOM.render(
      <CuposItem data={data} />
      , element
    );
  }

  renderMonthTooltip = (data, element) => {
    var test = data;
    ReactDOM.render(
      <div className="tooltip-aperturas-mes">
        <div className="top-info">
          <div className="info">
            <span className="title">{data.text}</span>
            <div className="date">{`${new Date(data.StartDate).toLocaleDateString()} - ${new Date(data.EndDate).toLocaleDateString()}`}</div>
          </div>
          <div className="buttons">
            <Button className="edit-button" onClick={() => this.handleEdit(data)}>
              <i className="material-icons">create</i>
            </Button>
            <Button className="delete-button" onClick={() => this.handleDelete(data.Id)}>
              <i className="material-icons">delete</i>
            </Button>
          </div>
        </div>
        <div className="dias-info">
          {data.QuotaSummary.map((item) => (
            <div key={`day-${item.Day}`} className="day">
              <div className="text">{numberToDay(item.Day)}</div>
              <div className="numbers">
                {item.Quotas.map((quota) => (
                  <span className={`item-${quota.Quota.Id}`} key={`${quota.Quota.Description}- ${item.Day}`}>{`${quota.AmmountQuota} + ${quota.AmmountOverQuota}`}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      , element
    );
  }

  renderWeekTooltip = (data, element) => {
    ReactDOM.render(
      <div>
        cupos,
      </div>
      , element
    );
  }

  render() {
    const source = this.getDataSource();
    const end = this.getLastHour();
    const start = this.getFirstHour();

    return (
      <React.Fragment>
        <div className="headaer-filter-wrapper">
          <div className="header-filter-text-wrapper">
            <SelectBox
              label="Centros"
              Id="centros"
              searchEnabled
              placeholder="Listado de Centros"
              value={this.props.centerId}
              dataSource={this.props.centrosList}
              displayExpr="Description"
              valueExpr="Id"
              onValueChanged={this.handleChange}
            />
          </div>
          <div>
            <Button
              id="btnNuevaApertura"
              text="Nueva Apertura"
              type="success"
              onClick={this.openNewOpening}
            >
            </Button>
          </div>
        </div>

        <div className="scheduler-wrapper" >

          {this.props.isPopupWizardOpen === true && (<ModalWizard />)}
          <Scheduler
            className="opening-view-month"
            dataSource={source}
            defaultCurrentView={this.currentView}
            defaultCurrentDate={new Date()}
            editing={{
              allowAdding: false,
              allowDragging: false,
              allowResizing: false,
              allowUpdating: false,
              allowDeleting: false,
            }}
            startDayHour={start}
            showAllDayPanel={false}
            showCurrentTimeIndicator={false}
            endDayHour={end}
            timeCellTemplate={(data, index, element) => {
              let { text } = data;
              if (data.text === "") {
                text = validaciones.getTimeForInterval(this.lastTimeInterval, defaultInterval);
              } else {
                this.lastTimeInterval = text;
              }
              ReactDOM.render(<span>{text}</span>, element);
            }}
            onAppointmentClick={this.handleAppointmentClick}
            cellDuration={defaultInterval}
            views={[
              {
                name: dia,
                type: "day",
                maxAppointmentsPerCell: "unlimited",
                appointmentTemplate: this.renderWeekItem,
              },
              {
                name: semana,
                type: "week",
                maxAppointmentsPerCell: "unlimited",
                appointmentTemplate: this.renderWeekItem,
              },
              {
                name: mes,
                type: "month",
                maxAppointmentsPerCell: "auto",
                appointmentTemplate: this.renderMonthItem,
                appointmentTooltipTemplate: this.renderMonthTooltip,
              },
            ]}
            onAppointmentDblClick={(e) => {
              e.cancel = true;
            }}
            onOptionChanged={this.handleOptionChane}
          />
        </div >
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  listaAppointments: state.aperturasSel.listaAppointments,
  weekAppointments: state.aperturasSel.weekAppointments,
  config: state.aperturasSel.centerConfig,
  centrosList: state.aperturasSel.centrosList,
  listQuotes: state.aperturasSel.listQuotes,
  Opening: state.aperturasSel.Opening,
  centerId: state.aperturasSel.centerId,
  isPopupWizardOpen: state.aperturasSel.isPopupWizardOpen,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(OpenningScheduler);
